import RestrictedAccess from './RestrictedAccess'

const ViewerAccess = ({ children }) => {
    return (
        <RestrictedAccess
            allowedRoles={['Administrator', 'Editor', 'Viewer']}
        >
            {children}
        </RestrictedAccess>
    )
}

export default ViewerAccess